export const CATEGORIES_ALL = [
  { value: 'Bronce', label: 'Bronce' },
  { value: 'Plata', label: 'Plata' },
  { value: 'Oro', label: 'Oro' },
  { value: 'Diamante', label: 'Diamante' },
  { value: 'Todos', label: 'Todos' }
]
